import { Label } from '~components/web-components'
import { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { StyledSelect } from '~components/molecules/modal/modal.styles'
import { Z_INDEX } from '~types/z-index'
import { assembleValidations } from '~utils/form-validations'

export enum Variants {
  basic = 'basic',
  filters = 'filters',
}

export const SelectField = ({
  name,
  validations,
  placeholder,
  required,
  label,
  onChange,
  options,
  defaultValue,
  isDisabled,
  className,
}: any) => {
  const {
    control,
    formState: { errors, touchedFields },
    setValue,
    trigger,
  } = useFormContext()
  const handleChange = (
    event: React.SyntheticEvent | null,
    value: string,
    name: string,
  ) => {
    if (!value === null) return
    onChange?.(event, value, name)
    setValue(name, value)
    trigger(name)
  }

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue)
      trigger(name)
    }
  }, [defaultValue])

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={assembleValidations(required, validations)}
      render={({ field: { value, ref } }) => {
        return (
          <>
            {label && <Label id={name} label={label} required={required} />}
            <StyledSelect
              name={name}
              onChange={handleChange}
              options={options}
              placeholder={placeholder}
              className={className}
              ref={ref}
              value={value || defaultValue}
              disabled={isDisabled}
              error={
                touchedFields[name] && errors[name]
                  ? (errors[name]?.message as string)
                  : undefined
              }
              slotProps={{ popper: { style: { zIndex: Z_INDEX.Popup } } }}
            />
          </>
        )
      }}
    />
  )
}
